// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"16":"ai_assistant","61":"pdfviewer","100":"audiometry","563":"recharts","860":"manager","884":"admin"}[chunkId] + "." + {"16":"9399070e","61":"83a6821c","100":"f4499ce2","563":"df413d2b","860":"902bc727","884":"e374ea42"}[chunkId] + ".chunk.css";
};